/*
 * sticky block plugin
 */
;(function($) {
	function StickyBlock(options) {
		this.options = $.extend({
			holder: null,
			fixedClass : 'fixed',
			compareBlock: 'div',
			blockHeight: false,
			blockTop: false,
			heightRatio: false
		}, options);
		this.init();
	}
	StickyBlock.prototype = {
		init: function() {
			if(this.options.holder) {
				this.findElements();
				this.attachEvents();
			}
		},
		findElements: function() {
			this.holder = jQuery(this.options.holder);
			this.compareBlock = jQuery(this.options.compareBlock);
			this.win = jQuery(window);

			if (this.options.blockHeight){
				this.scrollHeight  = this.compareBlock.innerHeight();
			}

			if (this.options.blockTop){
				this.scrollHeight  = this.compareBlock.offset().top;
			}

			if (this.options.heightRatio){
				this.scrollHeight  = this.options.heightRatio;
			}
		},
		attachEvents: function() {
			// bind handlers scope
			var self = this;
			this.bindHandlers(['onScroll']);
			$(window).bind('scroll resize load', this.onScroll);
		},
		onScroll: function() {
			var self = this;
			self.scrollTop = self.win.scrollTop();
			if (self.scrollTop > self.scrollHeight){
				self.holder.addClass(self.options.fixedClass);
			} else {
				self.holder.removeClass(self.options.fixedClass);
			}
		},
		bindHandlers: function(handlersList) {
			var self = this;
			$.each(handlersList, function(index, handler) {
				var origHandler = self[handler];
				self[handler] = function() {
					return origHandler.apply(self, arguments);
				};
			});
		},
		makeCallback: function(name) {
			if(typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	// jQuery plugin interface
	$.fn.StickyBlock = function(opt) {
		return this.each(function() {
			new StickyBlock($.extend(opt, {holder: this}));
		});
	};
}(jQuery));
